import { BenchmarkThresholds } from './Benchmark'
import { Bottleneck } from './Bottleneck'
export type Operation = ProfilerOperation | MonitorOperation

export interface DefaultOperation {
    id: number
    identifier: string
    pageType: string
    benchmark?: BenchmarkThresholds | null
    name: string
    service: string
    bottlenecks?: Bottleneck
    serviceType?: 'php' | 'external'
    parentId: number | null
    active: boolean
    ignored: boolean
    failureThreshold: string
    alertAfterInterval?: string
    lastRecorded: string
    lastSuccessfulAt: string
}

export interface ProfilerOperation extends DefaultOperation {
    detailed: boolean
    no_details?: boolean
}

export function getPageTypeLabel(value: string): string {
    switch (value) {
        case 'unspecified':
            return 'Unspecified'
        case 'homepage':
            return 'Homepage'
        case 'category':
            return 'Category Page'
        case 'product':
            return 'Product Details'
        case 'search':
            return 'Search Results'
        case 'cart':
            return 'Cart'
        default:
            return ''
    }
}

export interface MonitorOperation extends DefaultOperation {
    new?: boolean
    averageResponse: number
    averageResponseChange: number | null
    worstResponse: number
    worstResponseChange: number | null
    maxResponse: number
    maxResponseChange: number | null
    avgMemory: number
    avgMemoryChange: number | null
    requests: number
    requestsChange: number | null
    impact: number
    errors: number
    errorsChange?: number | null
    prioritized?: boolean
    change?: number
    failureRateIncident?: number | null
    responseTimeIncident?: number | null
}
